import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export interface CustomerEquipments {
  [index: string]: boolean | string;
  isLoaded: boolean;
  equipmentNum: string;
  active: boolean;
}

export default async function GetEquipmentInfoSpecific(
  salesOrg: string,
  cusnum: string,
  onlyStatus?:boolean,
): Promise<CustomerEquipments[]> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      onlyStatus
    },
    url: `${BASE_URL}/api/customer/equipment?customerNum=${cusnum}`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetEquipmentInfoMultiple(
  salesOrg: string,
  cusnum: string[]
): Promise<CustomerEquipments[]> {
  let out: CustomerEquipments[] = [];
  let config: AxiosRequestConfig;

  for (let x of cusnum) {
    config = {
      method: "GET",
      params: {
        clientId: "100",
        salesOrg: salesOrg,
      },
      url: `${BASE_URL}/api/customer/equipment?customerNum=${x}`,
    };

    out = out.concat(
      await AXIOS_INSTANCE(config)
        .then((v) => v.data)
        .catch((err) => console.error(err))
    );
  }

  return out;
}
